import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResumeTotalService {
  total(valores: number[]): number {
    return valores.reduce((total, num) => total + num, 0);
  }

  calculateTotalCategory(bonuses: Record<string, number[]>, category: string): number {
    const total = bonuses[category]?.reduce((acc, valor) => acc + valor, 0) || 0;
    return Math.round(total * 100) / 100;
  }

  calculateAnnual(valor: number, factor: number = 0): number {
    return Math.round(valor * factor * 100) / 100;
  }
}
